import { SettingsIcon } from '../../../../../../../assets/svg/settings';
import { Checkbox } from '../../../../../../../components/checkbox/checkbox';
import { IconButton } from '../../../../../../../components/icon-button/icon-button';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../../hooks/use-modal-params';
import { useIikoStore } from '../../../../../../../store/use-iiko-store';
import { MenuIikoTableHeaderSettingsModal } from './menu-iiko-table-header-settings-modal/menu-iiko-table-header-settings-modal';
import s from './menu-iiko-table-header.module.css';

export const MenuIikoTableHeader = () => {
  const { t } = useLang();
  const { menu, putMenu } = useIikoStore();
  const menuSettingsModal = useModalParams('menuSettings');

  return (
    <div className={s.feature}>
      <Checkbox
        checked={menu?.is_on}
        onClick={() => putMenu({ ...menu, is_on: !menu?.is_on })}
        label={t('Активность меню')}
        className={s.checkbox}
      />
      <IconButton onClick={() => menuSettingsModal.handleOpenModal()}>
        <SettingsIcon />
      </IconButton>
      {menuSettingsModal.isOpen && (
        <MenuIikoTableHeaderSettingsModal onClose={() => menuSettingsModal.handleCloseModal()} />
      )}
    </div>
  );
};
